import { render, staticRenderFns } from "./activeYXStudentLists.vue?vue&type=template&id=60bce677&"
import script from "./activeYXStudentLists.vue?vue&type=script&lang=js&"
export * from "./activeYXStudentLists.vue?vue&type=script&lang=js&"
import style0 from "./activeYXStudentLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports